export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10197.0fe7af48.jpg";